module.exports = __webpack_public_path__ + "static/unity-8d37490d4121959e2e924bfc90695055.svg";